import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatTab, MatTabGroup} from '@angular/material/tabs';

import {
  CategoryModel,
  DrawingModel,
  EventRankingModel,
  GameModel,
  GroupRankingModel,
  TournamentCategoryModel,
  TournamentModel
} from 'shared/models';
import {TournamentCategoryUi} from '../tournament-category-ui/tournament-category-ui';

@Component({
  selector: 'tournaments-categories-ui',
  standalone: true,
  imports: [CommonModule, MatTab, MatTabGroup, TournamentCategoryUi],
  templateUrl: './tournaments-categories-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentsCategoriesUi {
  tournament: InputSignal<TournamentModel> = input.required<TournamentModel>();
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();
  groupsRankings: InputSignal<GroupRankingModel[]> = input.required<GroupRankingModel[]>();
  eventsRankings: InputSignal<EventRankingModel[]> = input.required<EventRankingModel[]>();
  activeTab: InputSignal<number> = input.required<number>();
  tabChange: OutputEmitterRef<number> = output<number>();

  protected categories: Signal<CategoryModel[]> = computed((): CategoryModel[] => {
    return (this.tournament().tournamentsCategories
      .map((models: TournamentCategoryModel): CategoryModel | undefined => {
        return models.category;
      })
      .filter((model: CategoryModel | undefined): boolean => !!model)) as CategoryModel[];
  });

  protected tournamentCategory: Signal<TournamentCategoryModel | undefined> = computed((): TournamentCategoryModel | undefined => {
    const tournamentCategory: TournamentCategoryModel = this.tournament().tournamentsCategories[this.activeTab()];
    if (tournamentCategory.category) {
      return tournamentCategory;
    }
    return undefined;
  });
}
